<template>
    <div class="section-title">
        <div class="section-title__title">
            {{ title }}
        </div>
        <router-link :to="`/${section_link}`" tag="div" class="section-title__all">
            Показать все
            <chevron-right-icon size="1x" class="custom-class"></chevron-right-icon>
        </router-link>
<!--        <div class="section-title__all">-->
<!--            -->
<!--        </div>-->
    </div>
</template>

<script>
    import { ChevronRightIcon } from 'vue-feather-icons'

    export default {
        name: "SectionTitle",
        props: {
            title: {
                type: String,
                default: ''
            },
            section_link: {
                type: String,
                default: '#'
            }
        },
        components: {
            ChevronRightIcon
        }
    };
</script>

<style scoped lang="scss">
    .section-title {
        height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 40px;
        > div {
            height: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            position: relative;
            &:after {
                position: absolute;
                bottom: 0;
                z-index: 10;

                display: block;
                content: "";
                height: 1px;
                width: 100%;
                background: linear-gradient(4.88deg, #7AC3C1 0%, #3FB0AB 100%);
            }
        }
        &:after {
            background-color: #E1E6EA;
            display: block;
            content: '';
            height: 1px;
            width: 100%;
            position: absolute;
            left: 0;
        }
        &__title {
            color: #3F4450;
            font-weight: 600;
            font-size: 24px;
            padding-bottom: 10px;
        }
        &__all {
            color: #686F83;
            font-size: 16px;
            height: 100%;
            cursor: pointer;
        }
    }
</style>
